var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconProfileActive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#038AB7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9 12.374c2.85 0 5.161-2.216 5.161-4.95 0-2.733-2.31-4.95-5.16-4.95s-5.16 2.217-5.16 4.95c0 2.734 2.31 4.95 5.16 4.95zm0 2.474c-4.274 0-7.74-3.324-7.74-7.424C5.16 3.324 8.626 0 12.9 0c4.276 0 7.741 3.324 7.741 7.424 0 4.1-3.465 7.424-7.74 7.424z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.221 24.747c0-5.467-4.62-9.899-10.32-9.899s-10.32 4.432-10.32 9.9m-2.581 0c0-6.835 5.776-12.374 12.9-12.374 7.126 0 12.901 5.54 12.901 12.373"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconProfileActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-profile-active.2e5fd9cae5ecaff13ba932506d52802f.svg";